module.exports = __webpack_public_path__ + "img/interswitch.15041546.png";